import RadioButtons from "./RadioButtonsExample";
import Popup from "./Popup";
import Button from "./Button";
import Ribbon from "./Ribbon";
import SmallDataTable from "./SmallDataTableExample";
import LargeDataTable from "./LargeDataTableExample";
import DateInput from "./DateInputExample";
import TimeInput from "./TimeInputExample";
import CollapseBar from "./CollapseExpandExample";
import Dropdown from "./DropdownExample";
import TextArea from "./TextArea";
import InputTxt from "./InputTxt";
import CardDisplay from "./CardDisplay";
import DataGridExample from "./DataGridExample";
import CheckBoxesObjExample from "./CheckBoxesObjExample";


// link css files
import './FrameworkComponents.css';

const popupClicked = () => {
    // do some thing here

    // close popup
    window.location.href = "#";
}

const acceptNote = () => {
    // do some thing here
    alert("You clicked on Accept note");
    window.location.href = "#";
}

function cancelClicked() {
 
    window.location.href = "#";
}

const FrameworkComponents = (props) => {

return (
    <div class="frameworkComponents">
      	<h1>Framework Components page.</h1>
		<p>This page is for linking the base framework components</p>
		<p>Please use the following format for including listed components</p>
		<div class="componentInfo">
			<hr/>
			<h1>Radio Component</h1>
			<table class="parameters" >
				<thead>
					<tr>
						<th>Parameter</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>id</td>
						<td>ID prefix which is appended by "_item_&lt;cnt&gt;" where cnt is count in order</td>
						<td>id=\{"radio_buttons"}</td>
					</tr>
				</tbody>
			</table>
			<RadioButtons/>
			<div>
				<h1>Popup</h1>
				<p>Description: Popup/Modal Window Element</p>
				<div>Source Include: ./Popup.js</div>
				<div>Required Includes: none (Button is already included in the Popup.js component)</div>
				<div>
                        {/* the href attribute needs to match the ID of the popup being opened  */}
						{/* same with the window.location.href value in the button onClick  */}
                        <a href="#popup_1">Popup from link with action buttons</a> <br/>
                        <Popup
                            id="popup_1"
                            title="Delete Prevention Note"
                            messageBold="Are you sure you want to delete this note?"
                            messageNormal="Once it has been deleted, it cannot be undone."
                            buttonList={[{
                                id: "button_1",
                                text: "Delete note",
                                eventHandler: popupClicked,
                                style: "button button--secondary"
                            }, {
                                id: "button_2",
                                text: "Accept note",
                                eventHandler: acceptNote,
                                style: "button button--primary"
                            }, {
                                id: "button_3",
                                text: "cancel",
                                eventHandler: cancelClicked,
                                style: "button button--tertiary"
                            }]}
                        />
						<br />
                        <a href="#popup_2">Info popup from link</a> <br/>
                        <Popup
                            id="popup_2"
                            title="Just some information"
                            messageNormal="Info popup with text confirmation. Close button on top right only!"
                        />
						<br />
                        <button
                            className="button button--primary"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "#popup_2";
                            }}
                        >
                            Info popup from Button
                        </button>
						<br />
						<button
                            className="button button--primary"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "#popup_1";
                            }}
                        >
                            Popup with action buttons from Button
                        </button>
						<br />
						 <Button
                           	id="button1"
                           	text="Popup From Button Component"
                          	styleName="button button--primary"
							onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "#popup_1";
                            }}
                            />
                    </div>
					<br />
				<table class="parameters"  >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>id</td>
						<td>ID of the popup being opened</td>
						<td>Example: id="popup_1" or id=&#123;"popup_" + 1&#125; where 1 can be a counter or other variable</td>
					</tr>
					<tr> 
						<td>title</td>
						<td>Title to display on the popup being opened</td>
						<td>Example: title="Delete Note"</td>
					</tr>
					<tr> 
						<td>messageBold</td>
						<td>Line/Lines of <span className="semi-bold">bolded text</span> to display on the popup being opened</td>
						<td>Example: messageBold="Are you sure you want to delete this note?"</td>
					</tr>
					<tr> 
						<td>messageNormal</td>
						<td>Line/Lines of text to display on the popup being opened</td>
						<td>Example: messageNormal="Once deleted, it cannot be undone."</td>
					</tr>
					<tr> 
						<td>buttonList</td>
						<td>List of button objects that should appear on the popup (Confirm, Cancel, Accept, etc.)</td>
						<td>
							Example with one button: 
							buttonList=&#123;&#91;&#123;
                                id: "button_1",
                                text: "Delete note",
                                eventHandler: popupClicked,
                                style: "button button--secondary"
							&#125;&#93;&#125;
							<br />
							<span class="semi-bold">Note: </span> The href attribute of a link or the value assigned to window.location.href in a button's onClick to open a popup <span class="semi-bold">must</span> match the ID of the popup being opened
							<br />
							Example: &lt;a href="#popup_1"&gt; or &lt;button onClick=&#123;(e) =&gt; &#123;
                                e.preventDefault();
                                window.location.href = "#popup_1";
                            &#125;&#125; will both open the Popup with id="popup_1"
						</td>
					</tr>
				</tbody>
			</table>
				<h1>IdleTimerContainer</h1>
				<table  class="parameters" >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>timeout</td>
						<td>enter timeout in minutes, default is 26 minutes</td>
						<td>Example: timeout="20"</td>
					</tr>
					<tr> 
						<td>label</td>
						<td>Enter verbiage. Default is "Your session is about to expire."</td>
						<td>Example: label='Your session is about to expire.'</td>
					</tr>
					<tr> 
						<td>logouturl</td>
						<td>Enter the logout URL. Default is "http://chwebprod.tch.harvard.edu/chlogin/home.do"</td>
						<td>Example: logouturl='http://chwebprod.tch.harvard.edu/chlogin/home.do'</td>
					</tr>
				</tbody>
			</table>
			
			</div>
			<div>
				<h1>Top Nav</h1>
				<p>Description: Top Navigation menu containing links to all pages in the app\</p>
				<div>Source Include: ./Layout.js in App.js file</div>
				<div>Required Includes: none (Layout.js includes all required imports)</div>
				<div>Navigation.js contains the list of individual pages in the application</div>
				<div>
					MenuProvider.js creates the context for the menu to allow it to be available across the application<br />
					Layout.js includes MenuProvider.Provider; the navigation items subscribe to the Provider to be notified of any changes<br />
					TopNav.js includes MenuProvider.Consumer. The Provider sends any changes to the consumer to allow the menu to re-render (for example, changing the "selected" class on a nav item if the user clicks to another page)
				</div>
				<table  class="parameters" >
					<thead>
						<tr>
							<th>Parameter/Prop</th><th>Details</th><th>Example</th>
						</tr>
					</thead>
					<thead>
						<tr>
							<th colspan="3">Layout.js</th>
						</tr>
					</thead>
					<tbody>
						<tr> 
							<td>longTitle</td>
							<td>Long title of the application</td>
							<td>longTitle="Emergency Management Call Logs"</td>
						</tr>
						<tr> 
							<td>shortTitle</td>
							<td>Short title of the application</td>
							<td>shortTitle="EM Call Logs"</td>
						</tr>
						<tr> 
							<td>version</td>
							<td>The current version number of the application</td>
							<td>version="1.0.new"</td>
						</tr>
						<tr> 
							<td>versionLink</td>
							<td>Link to other versions of the application (if applicable)</td>
							<td>versionLink="https://www.childrenshospital.org/"</td>
						</tr>
						<tr> 
							<td>navMap</td>
							<td>Component that provides the list of pages the user can navigate between. Pages and their associated components are defined in Navigation.js</td>
							<td>
								navMap=&#123;navigation&#125;
							</td>
						</tr>
					</tbody>
					<thead>
						<tr>
							<th colspan="3">TopNav.js</th>
						</tr>
					</thead>
					<tbody>
						<tr> 
							<td>hideMenu</td>
							<td>Triggers state change to hide the menu</td>
							<td>
								hideMenu=&#123;hideMenu&#125;<br />
								State change state is defined in Layout.js and passed down to TopNav
							</td>
						</tr>
						<tr> 
							<td>showMenu</td>
							<td>Triggers state change to show the menu</td>
							<td>
								showMenu=&#123;showMenu&#125;<br />
								State change state is defined in Layout.js and passed down to TopNav
							</td>
						</tr>
						<tr> 
							<td>navMap</td>
							<td>
								Component that provides the list of pages the user can navigate between. <br />
								Pages and their associated components are defined in Navigation.js<br />
								navMap is passed in as a prop to TopNav from Layout
							</td>
							<td>
								navMap=&#123;navigation&#125;
							</td>
						</tr>
					</tbody>
					<thead>
						<tr>
							<th colspan="3">Navigation.js - Defines the list of pages in the menu. Does not take any props. Page Definitions listed.</th>
						</tr>
					</thead>
					<tbody>
						<tr> 
							<td>404</td>
							<td>
								Component definition for 404 (Page Not Found)
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123;
	                                to: "/404", 
									text: "404", 
									component: NotFound, 
									displayOrder: 6 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>AODForm</td>
							<td>Component definition for AOD Call Log Form
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123; 	
									to: "/AODForm", 
									text: "AOD Call Log Form", 
									component: AODForm, 
									displayOrder: 1 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>CallTypes</td>
							<td>Component definition for Call Types
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								 &#123; 
									to: "/CallTypes", 
									text: "Call Types", 
									component: CallTypes, 
									displayOrder: 4 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>Login</td>
							<td>Component definition for Login
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123; 
									to: "/login", 
									text: "Login", 
									component: Login, 
									displayOrder: 7 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>ManageAdministrators</td>
							<td>Component definition for Manage Administrators
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123; 
									to: "/ManageAdmins", 
									text: "Manage Administrators", 
									component: ManageAdmins, 
									displayOrder: 5 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>ManageUsers</td>
							<td>Component definition for Manage Users
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123;
									to: "../pages/ManageUsers", 
									text: "Manage Users", 
									component:ManageUsers, 
									displayOrder: 3 
								&#125;
							</td>
						</tr>
						<tr> 
							<td>MonthlyCallLog</td>
							<td>Component definition for Manage Users
								<ul>
									Required values:
									<li>to: The relative link of the page</li>
									<li>text: The text that will display</li>
									<li>component: The name of the page component, imported from framework/pages</li>
									<li>displayOrder: The order where this page should display in the menu. Currently not implemented</li>
								</ul>
							</td>
							<td>
								&#123;
									to: "/MonthlyCallLogs", 
									text: "Monthly Call Logs", 
									component: MonthlyCallLogs, 
									displayOrder: 2 
								&#125;
							</td>
						</tr>
					</tbody>
				</table>

				<br/>
				<h1>Ribbon</h1>
				<table  class="parameters"  >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>status</td>
						<td>checkmark or error</td>
						<td>Example: status={"checkmark"}</td>
					</tr>
					<tr> 
						<td>label</td>
						<td>Top header</td>
						<td>Example: label={"header goes here"}</td>
					</tr>
					<tr> 
						<td>subheader</td>
						<td>Sub Header</td>
						<td>Example: subheader={"sub header goes here"}</td>
					</tr>
					<tr> 
						<td>content</td>
						<td>General content</td>
						<td>Example: content={"enter your details here"}</td>
					</tr>
				</tbody>
				</table>
				<Ribbon label={"label only"} status={"checkmark"} subheader={""} content={""} />
				<Ribbon label={"label only"} status={"error"} subheader={""} content={""} />
				<Ribbon label={"label goes here"} subheader={"sub header goes here"} content={"Autem vel eum iure reprehenderit qui in ea voluptate. velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla. Autem vel eum iure reprehenderit qui in ea voluptate. velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla. Autem vel eum iure reprehenderit qui in ea voluptate. velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla."} status={"error"} />
				<Ribbon label={"label goes here, long long long long long long"} subheader={"sub header goes here"} content={"Autem vel eum iure reprehenderit qui in ea voluptate. velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla."} status={"checkmark"} />
			</div>
				<h1>Data Table</h1>
				<p>Description: Data table, to display data returned from a back end service as a JSON object</p>
				<div>Source Include: ./framework/Small Data TableExample.js or ./framework/LargeDataTableExample.js in App.js file as examples</div>
				<div>Source Include for Data Table component: ./framework/DataTable.js</div>
				<div>DataTable.js contains the actual table component, in addition to the sort and download to CSV functions</div>
				<table  class="parameters">
				<thead>
					<tr>
						<th>Parameter/Prop (for DataTable Component)</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>dataSource</td>
						<td>JSON object containing the data to populate the table</td>
						<td>Usually returned from a back end service, but can be defined directly in the file including DataTable.js</td>
					</tr>
					<tr> 
						<td>columns</td>
						<td>Column names for the data table</td>
						<td>Usually returned from a back end service, but can be defined directly in the file including DataTable.js</td>
					</tr>
					<tr> 
						<td>label</td>
						<td>Columns that have specific sorting behavior</td>
						<td>Columns that have specific sorting behavior (for example, filtering on Yes/No instead of the standard ascending/descending)</td>
					</tr>
					<tr> 
						<td>onSelect</td>
						<td>OnSelect Handler</td>
						<td>Function that defines what should happen when a row of the table is clicked. Should be defined in the component that includes the table, and then passed in as a prop to DataTable</td>
					</tr>
					<tr> 
						<td>id</td>
						<td>Table ID</td>
						<td>The ID of the table</td>
					</tr>
					<tr> 
						<td>exportCSV</td>
						<td>Export to CSV flag</td>
						<td>Boolean flag to indicate whether this data table can be downloaded as a CSV file</td>
					</tr>
					<tr> 
						<td>mobileViewSortEnable</td>
						<td>Mobile View sort flag</td>
						<td>Boolean flag to indicate whether column sorting should be enabled on a mobile device</td>
					</tr>
				</tbody>
				</table>
			<SmallDataTable />
			<LargeDataTable />
			
			<br/>
				<h1>Date Input Component</h1>
				<table  class="parameters"  >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>Id</td>
						<td>componentId</td>
						<td>id=props.id</td>
					</tr>
					<tr> 
						<td>Place Holder</td>
						<td>format of the date</td>
						<td>placeholder="mm/dd/yyyy"</td>
					</tr>
					<tr> 
						<td>showMeridian</td>
						<td></td>
						<td>showMeridian no parameter</td>
					</tr>
					<tr> 
						<td>ranges</td>
						<td>Define ranges of date and predefine date</td>
						<td>Example: ranges= label"Today" value: new Date()</td>
					</tr>
					<tr> 
						<td>style</td>
						<td>Style</td>
						<td>style=width:props.width, position:relative</td>
					</tr>
				</tbody>
				</table>
			
			<br/>
			
			<DateInput />
              
			
			<br/>
				<h1>Time Input Component</h1>
				<table  class="parameters"  >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>Id</td>
						<td>componentId</td>
						<td>id=props.id</td>
					</tr>
					<tr>  
						<td>Value</td>
						<td>format of the time</td>
						<td>value=new Date</td>
					</tr>
					<tr> 
						<td>label</td>
						<td></td>
						<td>label=time</td>
					</tr>
					<tr> 
						<td>isRequired</td>
						<td>Define if time is requires</td>
						<td>Example: true or false</td>
					</tr>
				</tbody>
				</table>
			<TimeInput />
			<br/>
				<h1>Collapse Component</h1>
				<table  class="parameters"  >
				<thead>
					<tr>
						<th>Parameter/Prop</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>Id</td>
						<td>componentId</td>
						<td>id=props.id</td>
					</tr>
				</tbody>
				</table>
			<CollapseBar/>
			
			<h1>Dropdown Component</h1>
			<table  class="parameters"  >
			<thead>
				<tr>
					<th>Parameter/Prop</th><th>Details</th><th>Example</th>
				</tr>
			</thead>
			<tbody>
				<tr> 
					<td>Id</td>
					<td>componentId</td>
					<td>id=dropdown_name</td>
				</tr>
				<tr> 
					<td>isDisabled</td>
					<td>Determine if dropdown should be disabled</td>
					<td>isDisabled={false}</td>
				</tr>
				<tr> 
					<td>isRequired</td>
					<td>Determines if dropdown is required</td>
					<td>isRequired={true}</td>
				</tr>
				<tr> 
					<td>helpMessage</td>
					<td>Added a message to the dropdown</td>
					<td>helpMessage=""</td>
				</tr>
				<tr> 
					<td>label</td>
					<td>Dropdown label</td>
					<td>label="Drop down 4, not pre-selected"</td>
				</tr>
				<tr> 
					<td>name</td>
					<td>The name of the dropdown</td>
					<td>name="dropdown_1"</td>
				</tr>
				<tr>
					<td>data</td>
					<td>The JSON object containing the data to populate the drop-down. Should contain key/value pairs for the value of the option, the label, and a boolean indicating whether this option should be pre-selected.</td>
					<td>
						Example (for one &lt;option&gt; tag):<br />
						&#123; value: 1, label: "option 1", selected: false &#125;
					</td>
				</tr>
				<tr>
					<td>disableDefault</td>
					<td>Indicates whether a default option is shown on the dropdown. Defaults to false, so a default "select one" option would be shown.</td>
					<td>
						disableDefault=&#123; false &#125;						
					</td>
				</tr>
				<tr>
					<td>defaultLabel</td>
					<td>The text label that will display for the dropdown default option, if disableDefault (above) is set to "false".</td>
					<td>
						defaultLabel=&#123; Select an Option &#125;
					</td>
				</tr>
			</tbody>
			</table>
			<Dropdown/>
			<br/>
			
			<h1>TextArea Component</h1>
			<table  class="parameters"  >
			<thead>
				<tr>
					<th>Parameter/Prop</th><th>Details</th><th>Example</th>
				</tr>
			</thead>
			<tbody>
				<tr> 
					<td>id</td>
					<td>componentId</td>
					<td>id="textarea_1"</td>
				</tr>
				<tr> 
					<td>labelText</td>
					<td>label</td>
					<td>labelText="Enter Description"</td>
				</tr>
				<tr> 
					<td>isDisabled</td>
					<td>Determine if disable</td>
					<td>isDisabled={false}</td>
				</tr>
				<tr> 
					<td>isRequired</td>
					<td>Determine if required</td>
					<td>isRequired={true}</td>
				</tr>
				<tr> 
					<td>rows</td>
					<td>The numder of rows displayed</td>
					<td>rows={4}</td>
				</tr>
				<tr> 
					<td>errorMessage</td>
					<td>Error message to user</td>
					<td>errorMessage={"error must not be blank"}</td>
				</tr>
				<tr> 
					<td>maxLength</td>
					<td>max length allowed</td>
					<td>maxLength={20}</td>
				</tr>
				<tr> 
					<td>value</td>
					<td>enter the value if any</td>
					<td>value=</td>
				</tr>
				<tr> 
					<td>getTextString</td>
					<td>enter the getTextString if needed</td>
					<td>getTextString=</td>
				</tr>
			</tbody>
			</table>
			<TextArea />
			
			
			
			<h1>InputTxt Component</h1>
             <table  class="parameters"  >
             <thead>
                   <tr>
                          <th>Parameter/Prop</th><th>Details</th><th>Example</th>
                   </tr>
             </thead>
             <tbody>
                   <tr> 
                          <td>id</td>
                          <td>componentId</td>
                          <td>id="inputtxt_1"</td>
                   </tr>
                   <tr> 
                          <td>labelText</td>
                          <td>label</td>
                          <td>labelText="Enter Description"</td>
                   </tr>
                   <tr> 
                          <td>isDisabled</td>
                          <td>Determine if disable</td>
                          <td>isDisabled={false}</td>
                   </tr>
                   <tr> 
                          <td>isRequired</td>
                          <td>Determine if required</td>
                          <td>isRequired={true}</td>
                   </tr>
                   <tr> 
                          <td>type</td>
                          <td>The type of Input</td>
                          <td>type=text</td>
                   </tr>
				   <tr> 
                          <td>hasError</td>
                          <td>Boolean to trigger error message display</td>
                          <td>hasError=touched.inputtxt1 && errors.inputtxt1</td>
                   </tr>
                   <tr> 
                          <td>errorMessage</td>
                          <td>Error message to user</td>
                          <td>errorMessage={"error must not be blank"}</td>
                   </tr>
                   <tr> 
                          <td>maxLength</td>
                          <td>max length allowed</td>
                          <td>maxLength={20}</td>
                   </tr>
                   <tr> 
                          <td>value</td>
                          <td>enter the value if any</td>
                          <td>value=</td>
                   </tr>
                   <tr> 
                          <td>getTextString</td>
                          <td>enter the getTextString if needed</td>
                          <td>getTextString=</td>
                   </tr>
				   <tr> 
                          <td>onChange</td>
                          <td>Name of onChange handler</td>
                          <td>onChange=handleChange</td>
                   </tr>
				   <tr> 
                          <td>className</td>
                          <td>className for stylesheet reference</td>
                          <td>className=”InputTxt”</td>
                   </tr>
				   <tr> 
                          <td>helpMessage</td>
                          <td>Help Message to display</td>
                          <td>helpMessage=</td>
                   </tr>
				   <tr> 
                          <td>onBlur</td>
                          <td>Name of onBlur handler</td>
                          <td>onBlur=handleBlur</td>
                   </tr>
				   <tr> 
                          <td>placeholder</td>
                          <td>Displays short hint of expected value for input field</td>
                          <td>placeholder=</td>
                   </tr>
             </tbody>
             </table>

			<br/>
			<InputTxt labelText='Input Text Box:'/>
			
			<h1>Card Component</h1>
             <table  class="parameters"  >
             <thead>
                   <tr>
                          <th>Parameter/Prop</th><th>Details</th><th>Example</th>
                   </tr>
             </thead>
             <tbody>
                   <tr> 
                          <td>id</td>
                          <td>componentId</td>
                          <td>id="card1"</td>
                   </tr>
                   <tr> 
                          <td>data</td>
                          <td>Card Data Object</td>
                          <td>data=&#123;cardObject&#125;
                            <div>&nbsp;</div>
                            <div><u><b>The object holding the card data should be defined in an object similar to the one shown below:</b></u></div>
                            <div>&nbsp;</div>
                          	<div>const cardObject = &#123;</div>
	    						<div><b>name:</b> "Charles M. Tiberio",</div>
	    						<div><b>id:</b> "CH123456",</div>
	    						<div><b>title:</b> "Director, Financial Reporting",</div>
	    						<div><b>department:</b> "Controller - Management",</div>
	    						<div><b>phone:</b> "617-218-1234",</div>
	    						<div><b>email:</b> "germain.harper@childrens.harvard.edu",</div>
	    						<div><b>address</b>: "100 Longwood Ave, Building",</div>
	    						<div><b>pager:</b> "12345",</div>
	    						<div><b>photo:</b> "https://uploads.codesandbox.io/uploads/user/38ce02f1-7e6f-449d-8351-5096bfbfc8ed/VaRz-pexels-pixabay-220453.jpg"</div>
  							<div>&#125;;</div>
                          </td>
                   </tr>
                   
             </tbody>
             </table>

			<br/>
			<CardDisplay />
			<div>
				<p>Description: Data grid, to display data returned from a back end service as a JSON object</p>
				<div>Source Include: ./framework/DataGridExample.js as an example</div>
				<div>Source Include for Data Table component: ./framework/DataGrid.js</div>
				<div>DataGrid.js contains the actual grid component, in addition to action buttons (Edit, Delete, etc.). The Data Grid supports 0, 1 or 2 buttons per row.</div>
				<table  class="parameters">
				<thead>
					<tr>
						<th>Parameter/Prop (for Data Grid Component)</th><th>Details</th><th>Example</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>data</td>
						<td>JSON object containing the data to populate the grid</td>
						<td>Usually returned from a back end service, but can be defined directly in the file including DataGrid.js</td>
					</tr>
					<tr> 
						<td>button1Action</td>
						<td>Click handler for the first button in the data row</td>
						<td></td>
					</tr>
					<tr> 
						<td>button2Action</td>
						<td>Click handler for the second button in the data row</td>
						<td></td>
					</tr>
				</tbody>
				<thead>
					<tr>
						<th colspan="3">Data Elements passed into Data Grid (the key/value pairs required in the JSON object)</th>
					</tr>
				</thead>
				<tbody>
					<tr> 
						<td>id</td>
						<td>The ID of the current row</td>
						<td>id: "001"</td>
					</tr>
					<tr> 
						<td>label</td>
						<td>The label for the current row</td>
						<td>Example: First Name, Last Name, Email, etc.</td>
					</tr>
					<tr> 
						<td>content</td>
						<td>The row data or text content</td>
						<td>Example: Judith Mahoney</td>
					</tr>
					<tr> 
						<td>contentType</td>
						<td>The type of content in the row</td>
						<td>String, Money, Phone, Email, Link. Defaults to String if not specified</td>
					</tr>
					<tr> 
						<td>contentLink</td>
						<td>The URL, if the contentType is an email or a link</td>
						<td></td>
					</tr>
					<tr> 
						<td>button1Label</td>
						<td>The label of the first button in the row. Button will be hidden if this is empty.</td>
						<td>Example: button2Label: "Edit"</td>
					</tr>
					<tr> 
						<td>button1Style</td>
						<td>The CSS style that should be applied to the button. Will default to button button--primary if not specified</td>
						<td>Example: button1Style: "button button--primary" </td>
					</tr>
					<tr> 
						<td>button1IsDisabled</td>
						<td>Boolean indicating if the button should be disabled. Defaults to false if not specified</td>
						<td>button1IsDisabled: false</td>
					</tr>
					<tr> 
						<td>button2Label</td>
						<td>The label of the first button in the row. Button will be hidden if this is empty.</td>
						<td>Example: button2Label: "Delete" </td>
					</tr>
					<tr> 
						<td>button2Style</td>
						<td>The CSS style that should be applied to the button. Will default to button button--primary if not specified</td>
						<td>Example: button2Style: "button button--primary" </td>
					</tr>
					<tr> 
						<td>button2IsDisabled</td>
						<td>Boolean indicating if the button should be disabled. Defaults to false if not specified</td>
						<td>Example: button2IsDisabled: false</td>
					</tr>
				</tbody>
				</table>
				<DataGridExample />
			</div>
		
			
			<br/>
			<br/>
			<CheckBoxesObjExample />
		</div>
    </div>
	);
}

export default FrameworkComponents;
